import { Component, forwardRef, OnInit, Input, ViewChild, Output, EventEmitter,Inject } from '@angular/core';
import { Account, Plan } from 'src/app/models/AccountModel';
import { AccountAssessment } from 'src/app/models/AssessmentModel';
import { ResultFilter, PlatformApiService, PlanSearchCriteria } from 'src/app/services/platform-api.service';
import { DataTableComponent } from 'src/app/shared/tile-data-table/tile-data-table.component';
import { AssessmentService } from 'src/app/services/assessment.service';
import { SessionService } from 'src/app/services/session.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmationComponent } from 'src/app/shared/confirmation.component';
import { BuyNowPromptComponent } from 'src/app/shared/buynow-prompt.component';
import { Assessment } from 'src/app/models/AssessmentModel';
import { AssessmentTypeListComponent } from 'src/app/secured/assessment/assessment-type-list.component';

@Component({
  selector: 'cw-ci-account-assessment-list',
  templateUrl: './account-assessment-list.component.html',
  styleUrls: ['./account-assessment-list.component.scss']
})
export class AccountAssessmentListComponent implements OnInit {

  @Input() parentAccount: Account;
  @Input() account: Account;

  @Output() stateChange: EventEmitter<any> = new EventEmitter();
  @ViewChild(DataTableComponent, { static: true }) assessmentDataTable: DataTableComponent;
  assessmentList: AccountAssessment[];
  availablePlans: Plan[];
  allAssessments: Assessment[];

  constructor(private _platformApi: PlatformApiService, public sessionService: SessionService, public dialog: MatDialog) { }

  ngOnInit() {
  }

  isSelectable(assessment) {
    return true;
  }

  loadAssessments(filter: ResultFilter) {
    let assessmentListObservable;
    filter.searchData.excludedAssessmentTypes = ['CERTIFICATION'];
    if (this.parentAccount) {
      assessmentListObservable = this._platformApi.getAccountAssessments(this.parentAccount.id, this.account.id, filter);
    } else {
        assessmentListObservable = this._platformApi.getAccountAssessments(this.account.id, undefined, filter);
    }

    assessmentListObservable.subscribe(results => {
      this.assessmentList = results;
      console.log(results);
    })

  }

  selectAssessment(selectedAssessment: AccountAssessment) {
    if (selectedAssessment.status == 'COMPLETED') {
      this.stateChange.emit({ state: 'ASSESSMENT_REPORT', accountAssessment: selectedAssessment, account: this.account });
    } else {
      this.stateChange.emit({state:'EDIT_ASSESSMENT', accountAssessment: selectedAssessment, account: this.account});
    }
  }

  newAssessment(selectedAssessment: AccountAssessment) {
    if (this.sessionService.hasFeature('ALLOW_REASSESSMENT')) {
      let cAccountId;
      let pAccountId = (this.parentAccount != undefined) ? this.parentAccount.id : undefined;
      if (pAccountId == this.account.id) {
        pAccountId = undefined
        cAccountId = this.account.id
      } else if(pAccountId == undefined && this.account.parentId != null) {
        pAccountId = this.account.parentId;
      } else {
        cAccountId = (pAccountId == undefined) ? this.account.id : undefined;
      }
      this._platformApi.getPlans(new PlanSearchCriteria(true, undefined, pAccountId, undefined, cAccountId)).subscribe(plans => {
        this.availablePlans = plans.results;
        const planObj = this.availablePlans[0];
        if (planObj) {
          this.assessmentDataTable.executeLoadItems();
          this._platformApi.getAssessments(new ResultFilter(undefined, undefined, undefined,undefined, {planId: this.account.planSubscription.planId, isInTrial: this.account.isInTrial(), excludeTypeList: ['CERTIFICATION'], accountId: this.account.id}))
            .subscribe(assessmentTemplates => {
            if (assessmentTemplates.count > 1) {
              const dialogRef = this.dialog.open(AssessmentTypeListComponent, {
                panelClass: 'flush-dialog',
                data: {planId: this.account.planSubscription.planId, isInTrial: this.account.isInTrial()},
                disableClose: false,
                autoFocus: false,
              });
              dialogRef.afterClosed().subscribe(selectedAssesValue => {
                if (selectedAssesValue != undefined) {
                  if (selectedAssessment.assessmentId == selectedAssesValue.value) {
                    this.displayConfirmationComponent(selectedAssessment);
                  } else {
                    this.newAssessmentSurvey(selectedAssessment, selectedAssesValue.value);
                  }
                }
              });
            } else {
              if (selectedAssessment.assessmentId == assessmentTemplates.results[0].id) {
                this.displayConfirmationComponent(selectedAssessment);
              } else {
                this.newAssessmentSurvey(selectedAssessment, assessmentTemplates.results[0].id);
              }
            }
          });
        }
      });
    } else {
      let msg = 'You have reached the assessment limit for your trial.  Please upgrade to a paid subscription to provide unlimited assessments to all of your customers.';
      if (this.sessionService.getCurrentAccount().parentId) {
        msg = 'This feature is not currently available. Please contact your administrator for assistance.'
      }
      const dialogRef = this.dialog.open(BuyNowPromptComponent, {
        panelClass: 'flush-dialog',
        data: { reason: 'FEATUREUNAVAILABLE', message: msg }
      });
    }
  }

  newAssessmentSurvey(selectedAssessment, selectedAssesValue) {
    const pAccountId = this.parentAccount ? this.parentAccount.id : selectedAssessment.accountId;
    const aId = this.parentAccount ? selectedAssessment.accountId : undefined;
    this._platformApi.getAccountAssessment(pAccountId, aId, selectedAssessment.id).subscribe(loadedAssessment => {
      const newAccountAssessment = new AccountAssessment({
        accountId: this.account.id,
        assessmentId: selectedAssesValue,
        prevId: selectedAssessment.id,
        surveyResultsJson: null
      });
      this._platformApi.saveAccountAssessment(this.parentAccount, newAccountAssessment).subscribe(accountAssessment => {
        loadedAssessment.nextId = accountAssessment.id;
        loadedAssessment.isLatest = false;
        this._platformApi.saveAccountAssessment(this.parentAccount, loadedAssessment).subscribe(prevAcctAssessment => {
          this.stateChange.emit({ state: 'EDIT_ASSESSMENT', accountAssessment, account: this.account });
        });
      });
    });
  }

  displayConfirmationComponent(selectedAssessment){
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      panelClass: 'flush-dialog',
      data: {
        promptTitle: 'Copy Answers',
        promptMessage: [
          'Do you want to copy the existing answers for this assessment into the new assessment?'
        ],
        closeLabel: 'Cancel',
        buttons: [{label:'No', value:'NO', color:'primary'}, {label:'Yes', value:'YES', color:'primary'}],
        height: 'auto'
      }
    });
    dialogRef.afterClosed().subscribe(keepAnswers => {
      if (keepAnswers != undefined) {
        const pAccountId = this.parentAccount ? this.parentAccount.id : selectedAssessment.accountId;
        const aId = this.parentAccount ? selectedAssessment.accountId : undefined;
        this._platformApi.getAccountAssessment(pAccountId, aId, selectedAssessment.id).subscribe(loadedAssessment => {
          const newAccountAssessment = new AccountAssessment({
            accountId: loadedAssessment.accountId,
            assessmentId: loadedAssessment.assessmentId,
            prevId: loadedAssessment.id,
            surveyResultsJson: (keepAnswers == 'YES') ? loadedAssessment.surveyResultsJson : null
          });
          this._platformApi.saveAccountAssessment(this.parentAccount, newAccountAssessment).subscribe(accountAssessment => {
            loadedAssessment.nextId = accountAssessment.id;
            loadedAssessment.isLatest = false;
            this._platformApi.saveAccountAssessment(this.parentAccount, loadedAssessment).subscribe(prevAcctAssessment => {
              this.stateChange.emit({ state: 'EDIT_ASSESSMENT', accountAssessment, account: this.account });
            });
          })
        });
      }
    });
  }

  getRiskColor(score) {
    const aServ = new AssessmentService();
    return aServ.getRiskColor({score});
  }

  getRiskLabel(score) {
    const aServ = new AssessmentService();
    return aServ.getRiskLabel({score});
  }
}
